import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Platform, MenuController, ModalController, ToastController, AlertController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AuthorService } from './services/author.service';
import { ToggleService } from './services/toggle.service';
import { Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { AuthenticationService } from './services/authentication.service';
import { FeedbackService } from './services/feedback.service';
import { PreviewService } from './services/preview.service';
import { AssetTypeService } from './services/asset-type.service';
import { ApiAssetService } from './api-services/asset.api.service';
import { RouterService } from './services/router.service';
import { CryptoService } from './services/crypto.service';
import { StorageService } from './services/storageService.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public authorService: AuthorService,
    private menu: MenuController,
    public router: Router,
    public toggleService: ToggleService,
    public alertController: AlertController,
    public toastController: ToastController,
    private renderer2: Renderer2,
    public feedbackService: FeedbackService,
    public authService: AuthenticationService,
    public activatedRoute: ActivatedRoute,
    public previewService: PreviewService,
    public assetTypeService: AssetTypeService,
    public assetAPIService: ApiAssetService,
    public routerService: RouterService,
    public cryptoService: CryptoService,
    public storageService: StorageService

  ) {
    authService.checkLogin();
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // this.router.navigateByUrl(this.authService.getLaunchUrl());
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });

    setInterval(() => {
      var smallchat = document.querySelector("#Smallchat");
      if (smallchat != null) {
        if (this.authService.isLoggedIn && window.location.href.indexOf('/author') <= -1) {
          document.querySelector("#Smallchat").style.display = "block";
          document.querySelector("#Smallchat iframe").style.width = "340px";
        } else {
          document.querySelector("#Smallchat").style.display = "none";
        }
      }
    }, 2500);
    // const s = this.renderer2.createElement('script');
    // s.type = 'text/javascript';
    // s.src = '/assets/preview-vr-scene.js';
    // s.text = ``;
    // this.renderer2.appendChild(this._document.body, s);
  }

  reportFeedback() {
    //this.modalController.create()
    this.presentFeedback();
  }

  async presentFeedback() {
    const alert = await this.alertController.create({
      header: 'Enter your feedback below to notify the eCom team',
      inputs: [
        {
          name: 'fullName',
          type: 'text',
          label: 'Full name:',
          placeholder: 'Full name',
          value: ""
        },
        {
          name: 'emailAddress',
          type: 'text',
          label: 'Email address:',
          placeholder: 'Email address',
          value: this.cryptoService.decryptData(this.storageService.getItem("login_email"))
        },
        {
          name: 'phoneNumber',
          type: 'text',
          label: 'Phone number:',
          placeholder: 'Phone number',
          value: ""
        },
        {
          name: 'category',
          type: 'text',
          label: 'Category (question/feedback/etc.):',
          placeholder: 'Category',
          value: "Question"
        },
        {
          name: 'message',
          type: 'text',
          label: 'Message:',
          placeholder: 'Message',
          value: ""
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
            //console.log('Confirm Cancel');
          }
        }, {
          text: 'Submit Feedback',
          handler: (data) => {
            try {
              if (data.fullName.length == 0) {
                this.presentToast("Feedback not recorded, please fill in all fields.");
              } else if (data.emailAddress.length == 0) {
                this.presentToast("Feedback not recorded, please fill in all fields.");
              } else if (data.phoneNumber.length == 0) {
                this.presentToast("Feedback not recorded, please fill in all fields.");
              } else if (data.category.length == 0) {
                this.presentToast("Feedback not recorded, please fill in all fields.");
              } else if (data.message.length == 0) {
                this.presentToast("Feedback not recorded, please fill in all fields.");
              } else {
                //     this.feedbackService.recordFeedback(data.fullName, data.emailAddress, data.phoneNumber, data.category, data.message);
                this.presentToast("Feedback successfully recorded.");
              }
            } catch {
              this.presentToast("Feedback not recorded, please fill in all fields.");
            }
          }
        }
      ]
    });

    await alert.present();
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000
    });
    toast.present();
  }
}
